module.exports = __webpack_public_path__ + "static/assets/9c4654ee7cd583a3a963eb39020b2d69.svg";